<div class="component-wrapper">
  <div class="middle-title">Macchine eliminate</div>
  <lib-full-table
    [actions]="machineTableActions"
    [columnList]="machineTableColumnList"
    [search]="machineTableSearch"
    [pageSize]="10"
    path="machine"
    [enableExport]="true"
    [join]="machineTableJoin"
    [quickSearchColumns]="machineTableQuickSearchColumns"
    [hideQuickSearchBar]="false"
    [includeDeleted]="true"
    [refresh]="refresh">
  </lib-full-table>
</div>
